/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */


import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollTop } from "../utils/AppUtil";

export const Top: React.FC = () => {
    const location = useLocation();
    
    useEffect(() => {
        setTimeout(() => {
            scrollTop();
        }, 500);
    }, [location]);
    
    return null;
}